import React from 'react';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import Eyecon from '../Icons/Eye';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';
var ViewStat = function (_a) {
    var deviation = _a.deviation, onlyNumbers = _a.onlyNumbers, className = _a.className;
    var _b = useDeviationStats(deviation), views = _b.views, isViewCountable = _b.isViewCountable;
    return !isViewCountable ? null : (React.createElement(Stat, { className: className, deviation: deviation, icon: Eyecon, statNameLocaleKey: "deviation.stats.views", statCount: views, onlyNumbers: onlyNumbers, biData: {
            evid: BiEventType.DEFAULT,
            click_info: 'views',
        } }));
};
ViewStat.displayName = 'ViewStat';
export default ViewStat;
//# sourceMappingURL=ViewStat.js.map